import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import LanguageSwitcher from '../components/language-switcher';

const TABS = ['BOXING', 'MUAY_THAI', 'KICKBOXING', 'MMA'];
const TAB_KEY_MAP = {
    BOXING: 'boxing',
    MUAY_THAI: 'muayThai',
    KICKBOXING: 'kickboxing',
    MMA: 'mma',
};

export default function Rules() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { t } = useTranslation();

    const activeTab = TABS.includes(searchParams.get('entry'))
        ? searchParams.get('entry')
        : 'BOXING';

    const eventId = searchParams.get('eventId');

    const handleClose = () => {
        if (eventId) navigate(`/event/${eventId}`);
        else navigate('/');
    };

    const tabKey = TAB_KEY_MAP[activeTab];
    const sections = t(`rules.${tabKey}.sections`, { returnObjects: true });

    return (
        <div className='page-size flex flex-col p-4 items-start gap-4'>
            <div className='flex flex-row justify-between items-center w-full top-2 left-4 p-2'>
                <LanguageSwitcher />
                <div className="flex-1" />
                <button className="btn btn-ghost btn-md btn-square" onClick={handleClose}>
                    <X />
                </button>
            </div>

            <p className='font-bold text-lg'>{t('rules.pageTitle')}</p>

            <div role="tablist" className="tabs tabs-boxed w-full flex-wrap">
                {TABS.map(tab => (
                    <button
                        key={tab}
                        role="tab"
                        className={`tab${activeTab === tab ? ' tab-active' : ''}`}
                        onClick={() => setSearchParams({ entry: tab })}
                    >
                        {t(`rules.tabs.${TAB_KEY_MAP[tab]}`)}
                    </button>
                ))}
            </div>

            <div className='prose max-w-none w-full pb-8'>
                <h2>{t(`rules.${tabKey}.title`)}</h2>
                {Array.isArray(sections) && sections.map((section, i) => (
                    <div key={i}>
                        {section.heading && <h3>{section.heading}</h3>}
                        {section.body && (
                            <p>
                                {section.body.startsWith('http')
                                    ? <a href={section.body} target="_blank" rel="noopener noreferrer">{section.body}</a>
                                    : section.body.split('\n\n').map((para, k) => (
                                        <React.Fragment key={k}>{para}{k < section.body.split('\n\n').length - 1 && <><br /><br /></>}</React.Fragment>
                                    ))
                                }
                            </p>
                        )}
                        {Array.isArray(section.numbered) && (
                            <ol>
                                {section.numbered.map((item, j) => <li key={j}>{item}</li>)}
                            </ol>
                        )}
                        {Array.isArray(section.items) && (
                            <ul>
                                {section.items.map((item, j) => (
                                    <li key={j}>
                                        {item.startsWith('http')
                                            ? <a href={item} target="_blank" rel="noopener noreferrer">{item}</a>
                                            : item
                                        }
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
